import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'react-bootstrap';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import { Contacts, TitleWMutedRow, ErrorBanner, AlertBanner } from '../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg } from '../../../sitel/demon/ui/atoms/form';
import { InputTextSingleColumn } from '../../../sitel/demon/ui/form';
import { useBaseUrlAuthFlow } from '../../../services/urlServices';
import authCentral from '../../../services/authCentral';
import { titleText } from '../../../components/utils/medstarAssociationTexts';
import useShowHidePassword from '../../new/step2Credentials/useShowHidePassword';

import schema from './formSchema';
import useFormSubmit from './useFormSubmit';
import SubmitButton from '../../../sitel/demon/ui/atoms/buttons/SubmitButton';

export default function Login() {
  //No one is supposed to get here if he is logged in.
  const user = authCentral.getCurrentUser();
  if(user){
    // REDIRECT TO CHOOSE APP INSTEAD OF LOGOUT auth.localLogout();
  }

  const { medstarAssociationType } = useParams();
  const language = titleText(medstarAssociationType);
  const [showHidePassword, setshowHidePassword] = useShowHidePassword();
  const navigate = useNavigate();
  const baseAuthUrl = useBaseUrlAuthFlow();
  const [loginError, setLoginError] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({ resolver: yupResolver(schema()) });
  const onSubmit = useFormSubmit(setLoginError);

  return (
    <>
      <AlertBanner>
        If you experience any issues creating your account online, <Contacts.SitelHelpDeskLanguage />.
      </AlertBanner>
      {loginError && <ErrorBanner errorText='The credentials you entered do not match a user in our system' />}
      <TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>

      <h4 className='mb-3'>Login</h4>

      <form onSubmit={handleSubmit(onSubmit)}>
        <InputTextSingleColumn labelText='Username' id='username' placeholder='@gmail.com @yahoo.com @hotmail.com etc' maxlength='50' register={register} errors={errors} showIsRequired />

        <div className='form-group'>
          <div className='form-group'>
            <NavLink className='float-end' to={`${baseAuthUrl}/resetpassword/step1/createrequest`}>
              <small>Forgot my password</small>
            </NavLink>
            <label htmlFor='sesame1'>Password</label>
            <div className='borderxnn position-relative'>
              <input type={showHidePassword.inputType} className='form-control border w-100' id='sesame1' placeholder='Password' {...register('sesame1')} />
              <span role='button' className='position-absolute top-50 end-0 translate-middle' onClick={setshowHidePassword}>
                <i className={`fa-regular ${showHidePassword.check ? 'fa-eye' : 'fa-eye-slash'}`}></i>
              </span>
            </div>
            <FieldValidationErrorMsg field='sesame1' errors={errors} />
          </div>
        </div>

        <div className='form-group'>
          <SubmitButton defaultLabel="Log in" loadingLabel="Logging in" isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful && !loginError} className="btn-medstar-primary w-100 mt-3"/>
        </div>

        <div className='form-group'>
          <Button
            variant='outline-light'
            type='button'
            className='btn-medstar-outline w-100 mt-2'
            onClick={() => {
              navigate(baseAuthUrl);
            }}
          >
            Create account
          </Button>
        </div>
      </form>
    </>
  );
}
